import _ from 'lodash';
import React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { inject, observer } from 'mobx-react';

import {
    Text,
    Select,
    Checkbox,
    Switch
} from 'common/components/field-factory/fields';
import ConfirmButton from 'common/components/confirm-button';

const injectStores = inject(
    ({
        artistStore,
        userStore,
        genreStore
    }) => ({ artistStore, userStore, genreStore })
);

export default injectStores(
    observer(({ artistStore, userStore, genreStore }) => {
        const { register, control, handleSubmit } = useForm();

        if (artistStore.isLoading || userStore.isLoading || genreStore.isLoading) {
            
            return null;
        }

        const user = userStore.data.user.toPOJO();
        const artist = artistStore.data.artist.toPOJO();
        
        if (_.isEmpty(artist) || _.isEmpty(user)) {

            return null;
        }

        const onSubmit = async (data) => {
            const { artist, user } = data;
            artist.genreID = artist.genre.value;

            console.log('onSubmit data', artist, user);
            const start = new Date().getTime();
            console.log('onSubmit start', start);
            await artistStore.updateItem(artist);
            await userStore.updateItem(user);
            console.log('onSubmit end', new Date().getTime() - start);
        };

		return (
            <div>
                <h2>Edit Information</h2>
				<div className="grid-x" data-ta="artistInfoForm">
					<div className="small-12 large-8 cell">
                        <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
                            <input type="hidden" { ...register('user._id') } defaultValue={ user._id } />
                            <input type="hidden" { ...register('artist._id') } defaultValue={ artist._id } />
                            <div className="grid-x">
                                <div className="small-12 large-4 cell">
                                    <Text
                                        label="Artist Name"
                                        fieldKey="artist.name"
                                        inputClass="admin-field"
                                        require={ true }
                                        defaultValue={ artist.name }
                                        register={ register }
                                    />
                                    <Text
                                        label="User Name"
                                        fieldKey="user.userName"
                                        inputClass="admin-field"
                                        require={ true }
                                        defaultValue={ user.userName }
                                        register={ register }
                                    />
                                    <Text
                                        label="Email"
                                        fieldKey="user.email"
                                        inputClass="admin-field"
                                        require={ true }
                                        defaultValue={ user.email }
                                        register={ register }
                                    />
                                    <Text
                                        label="Payment Service ID"
                                        fieldKey="artist.paymentServiceID"
                                        inputClass="admin-field"
                                        require={ true }
                                        defaultValue={ artist.paymentServiceID }
                                        register={ register }
                                    />
                                    <Text
                                        label="Date of Birth"
                                        fieldKey="user.dob"
                                        inputClass="admin-field"
                                        require={ true }
                                        defaultValue={
                                            new Date(user.dob).toLocaleDateString()
                                        }
                                        register={ register }
                                    />
                                    
                                </div>

                                <div className="small-12 large-4 cell">
                                    <Text
                                        label="First Name"
                                        fieldKey="user.firstName"
                                        inputClass="admin-field"
                                        require={ true }
                                        defaultValue={ user.firstName }
                                        register={ register }
                                    />
                                    <Text
                                        label="Last Name"
                                        fieldKey="user.lastName"
                                        inputClass="admin-field"
                                        require={ true }
                                        defaultValue={ user.lastName }
                                        register={ register }
                                    />
                                    <Text
                                        label="Phone Number"
                                        fieldKey="user.phoneNumber"
                                        inputClass="admin-field"
                                        require={ true }
                                        defaultValue={ user.phoneNumber }
                                        register={ register }
                                    />
                                    <Text
                                        label="Location"
                                        fieldKey="user.location"
                                        inputClass="admin-field"
                                        require={ true }
                                        defaultValue={ user.location }
                                        register={ register }
                                    />
                                    <Select
                                        label="Genre"
                                        fieldKey="artist.genre"
                                        className="admin-select"
                                        require={ true }
                                        control={ control }
                                        defaultValue={{
                                            value: artist.genre._id,
                                            label: artist.genre.label
                                        }}
                                        options={
                                            genreStore.genres.map(
                                                ({
                                                    _id: value,
                                                    label
                                                }) => ({ value, label })
                                            )
                                        }
                                    />
                                </div>
                            </div>
                            <div className="grid-x">
                                <div className="cell shrink padding-right-1">
                                    <button
                                        type="submit"
                                        data-ta="artistInfoSaveChanges"
                                        className="button neo large">
                                            Save Changes
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

					<div className="small-12 large-4 cell">
                        <Checkbox
                            label="Opt in to HFM Picks"
                            fieldKey="artist.hfmPicksOptIn"
                            inputClass="admin-field"
                            defaultValue={ artist.hfmPicksOptIn }
                            register={ register }
                        />
                        {/* <Switch
                            label="Artist Status"
                            fieldKey="artist.status"
                            inputClass="admin-switch"
                            require={ true }
                            isCheckedValue={ artist.status === 'ACTIVE' }
                            register={ register }
                        /> */}
						{/* <FieldWithStore inputClass="admin-field" fieldKey="artist.hfmPicksOptIn" store={ artistStore } /> */}
						{/* <FieldWithStore inputClass="admin-switch" fieldKey="artist.status" store={ artistStore } /> */}

						{/* <h4 className="padding-top-2">Set Default Password</h4>
						<ConfirmButton
							warningText={ 'Really reset to the default password? The new password will be "PleaseChangeM3!"' }
							onConfirmClick={ this.onResetPasswordConfirmClick }>
								<button className="button neo expanded">
									Set Default Password
								</button>
								<div>
									<em>The new password will be "PleaseChangeM3!"</em>
								</div>
						</ConfirmButton> */}
					</div>
				</div>

				<div className="grid-x grid-padding-y">
					<div className="cell auto">
						
					</div>
				</div>
				<div className="grid-x align-right">
					<div className="cell shrink">
						<ConfirmButton
							warningText={ `Really delete ${artistStore.get('artist.name')}?` }
							onConfirmClick={ 
                                async () => {
                                    try {

                                        await artistStore.deleteItem(artist);
                                        window.location.hash = '#/manage-artists/ACTIVE/TIER_1';
                                    } catch (err) {

                                        console.error('[ERROR DELETING ARTIST]', err);
                                    }
                                }
                             }
						>
						</ConfirmButton>
					</div>
				</div>
			</div>
		);
    })

	// @autobind
	// async onClick () {
	// 	const { artistStore, userStore } = this.props;

	// 	await artistStore.saveArtist();
	// 	await userStore.saveUser();
	// 	toast.success('Saved!');
	// }

	// @autobind
	// async onConfirmClick () {
	// 	const { artistStore } = this.props;
	// 	try {

	// 		await artistStore.deleteItem(artistStore.data.artist.toPOJO());
	// 		window.location.hash = '#/manage-artists/ACTIVE/TIER_1';
	// 	} catch (err) {

	// 		console.error('[ERROR DELETING ARTIST]', err);
	// 	}
	// }

	// @autobind
	// async onResetPasswordConfirmClick () {
	// 	const { apiStore, userStore } = this.props;
	// 	const data = await apiStore.setDefaultPassword(userStore.get('_id'));
	// 	toast.success('Password reset to default!');
	// }
)
